import React from 'react';

import {
  Breakpoints,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
  useIsMobile,
} from '@vw-marketing/us-components';

import {
  NoVehicleInteractiveCardContainer,
  NoVehicleInteractiveCardContent,
  NoVehicleInteractiveCTA,
  NoVehicleInteractiveCTAContainer,
} from './styled';
import { useFeatureServices } from '../../../../shared/hooks/use-feature-services';
import { useMyVwContext } from '../../../../shared/hooks/use-my-vw-context';
import Add from '../../../../shared/components/icons/Add';

const NoVehicleInteractiveCard = ({ handleClick }: { handleClick: Function }) => {
  const { translationHandler } = useMyVwContext();
  const {
    'locale-service': localeService,
    'navigation-service': navigateService
  } = useFeatureServices();
  const isCanada = localeService?.countryCode === 'CA';
  const isMobile = useIsMobile(Breakpoints.b560);
  const ctaSize = isMobile ? 'small' : 'large';
  const offersPageName: string = 'offers';
  const offersAppName: string = 'US-SofaTier1V1';

  const handleRedirect = () => {
    if (isCanada) return;

    if (!navigateService) return;

    const navigationObject = navigateService.navigateTo(offersPageName, {
      [offersAppName]: '/'
    })

    navigationObject?.push();
  }

  const noVehicle = (
    <NoVehicleInteractiveCardContainer>
      <NoVehicleInteractiveCardContent>
        <TextCustom
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight24,
              fontWeight: TextWeight.bold,
            },
            [Breakpoints.b1600]: {
              fontSize: TextSize.TextSize20,
              lineHeight: TextLineHeight.TextLineHeight28,
              fontWeight: TextWeight.bold,
            },
          }}
        >
          {translationHandler(
            'vehicleManagement.interactive.card.no.vehicle.tile',
          )}
        </TextCustom>
        <TextCustom
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize14,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b1600]: {
              fontSize: TextSize.TextSize16,
            },
          }}
        >
          {translationHandler(
            'vehicleManagement.interactive.card.no.vehicle.text',
          )}
        </TextCustom>
      </NoVehicleInteractiveCardContent>
      <NoVehicleInteractiveCTAContainer>
        <NoVehicleInteractiveCTA
          tag="a"
          emphasis="secondary"
          size={ctaSize}
          stretchContent={true}
          href={
            isCanada
              ? 'https://www.vw.ca/en/models/new-vehicles.html'
              : null
          }
          onClick={() => handleRedirect()}
        >
          {translationHandler(
            'vehicleManagement.interactive.card.no.vehicle.cta.left',
          )}
        </NoVehicleInteractiveCTA>
        <NoVehicleInteractiveCTA
          tag="button"
          emphasis="primary"
          icon={<Add />}
          size={ctaSize}
          stretchContent={true}
          onClick={() => handleClick()}
        >
          {translationHandler(
            'vehicleManagement.interactive.card.no.vehicle.cta.right',
          )}
        </NoVehicleInteractiveCTA>
      </NoVehicleInteractiveCTAContainer>
    </NoVehicleInteractiveCardContainer>
  );

  return <>{noVehicle}</>;
};

export default NoVehicleInteractiveCard;
